import styles from './Summary.module.scss';
import useGeofenceInteraction from '../useGeofenceInteraction';
import MapView from '@customer/components/maps/map-view/MapView';
import StartEndObjects from '@customer/components/maps/start-end-objects/StartEndObjects';
import usePositionsOnMap from '@customer/components/maps/hooks/usePositionsOnMap';
import InteractionSummaryGI from '@customer/components/data-display/interaction-summary-gi/InteractionSummaryGI';
import { LayersControl } from 'react-leaflet';
import Geofence from '@customer/components/maps/geofence/Geofence';
import { useTranslation } from 'react-i18next';

export function Summary() {
  const { t } = useTranslation();
  const { interaction } = useGeofenceInteraction();

  const { lo, geo } = interaction ?? {};

  const mapProps = usePositionsOnMap([lo?.startPos, lo?.endPos]);

  return (
    <div className={styles.container}>
      <InteractionSummaryGI interaction={interaction} />

      <div className={styles.map}>
        <MapView {...mapProps} showLayersControl={true}>
          {geo?.shape && (
            <LayersControl.Overlay name={t('Geofence')} checked>
              <Geofence key="geo" feature={geo.shape} />
            </LayersControl.Overlay>
          )}

          {lo?.startPos && <StartEndObjects startPos={lo.startPos} endPos={lo.endPos} />}
        </MapView>
      </div>
    </div>
  );
}

export default Summary;
